import {
  rcoPoBoxShipmentSegmentSchema,
  RcoSegmentStep,
} from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const PoBoxShipmentInspectorContent = memo(
  function PoBoxShipmentInspectorContent({ step }: { step: RcoSegmentStep }) {
    rcoPoBoxShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Condition
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Shipping address is a PO box
        </Text>
      </Flex>
    );
  },
);

export const EditablePoBoxShipmentInspectorContent = memo(
  function EditablePoBoxShipmentInspectorContent({
    step,
  }: {
    step: Omit<RcoSegmentStep, "matchingNextId" | "nonMatchingNextId"> & {
      matchingNextId?: string | undefined;
      nonMatchingNextId?: string | undefined;
    };
  }) {
    rcoPoBoxShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Condition
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Shipping address is a PO box
        </Text>
      </Flex>
    );
  },
);
